import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { supabase } from '../supabase';
import { createUserWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, onAuthStateChanged } from 'firebase/auth';
import { doc, setDoc, getDoc, collection, getDocs, query, where } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import CountdownTimer from '../components/CountdownTimer';
import './Registration.css';

const Registration: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
    institution: '',
    academicLevel: 'Estudante',
    country: 'Angola',
    interest: '',
    attendanceMode: 'Presencial',
    participatingAs: '',
    linhaPrincipal: '',
    linhasAdicionais: [] as string[],
    temaTrabalho: '',
    situacaoTrabalho: 'Em Andamento',
    numAutores: 1,
    autor2: '',
    autor3: ''
  });

  const [trabalhoFile, setTrabalhoFile] = useState<File | null>(null);
  const [isGroupMember, setIsGroupMember] = useState(false);
  const [checkingMembership, setCheckingMembership] = useState(false);

  const linhasInvestigacao = [
    "Crianças e direitos humanos",
    "Crianças, linguagens e culturas infantis",
    "Currículo e Práticas Pedagógicas na Educação Infantil",
    "Desenvolvimento Infantil e Aprendizagens",
    "Educação de bebês",
    "Educação de Infância, Familia e Comunidade",
    "Formação de professores de Educadores de Infância",
    "Infâncias e diversidades",
    "Neuroeducação e Primeira Infância",
    "Políticas Públicas para a Primeira Infância - Infra-Estrutura, Acesso e Financiamento"
  ];

  const pisesPopulares = ["Angola", "Brasil", "Portugal", "Cuba", "Moçambique"];
  const todosLosPaises = [
    "Afeganistão", "África do Sul", "Albânia", "Alemanha", "Andorra", "Anguila", "Antígua e Barbuda", "Arábia Saudita", "Argélia", "Argentina", "Armênia", "Aruba", "Austrália", "Áustria", "Azerbaijão",
    "Bahamas", "Bahrein", "Bangladesh", "Barbados", "Bélgica", "Belize", "Benim", "Bermudas", "Bielorrússia", "Bolívia", "Bonaire", "Bósnia e Herzegovina", "Botsuana", "Brunei", "Bulgária", "Burquina Faso", "Burundi", "Butão",
    "Cabo Verde", "Camarões", "Camboja", "Canadá", "Catar", "Cazaquistão", "Chade", "Chile", "China", "Chipre", "Colômbia", "Comores", "Congo-Brazzaville", "Congo-Kinshasa", "Coreia do Norte", "Coreia do Sul", "Costa do Marfim", "Costa Rica", "Croácia", "Curaçao",
    "Dinamarca", "Djibuti", "Dominica", "Egito", "El Salvador", "Emirados Árabes Unidos", "Equador", "Eritreia", "Eslováquia", "Eslovênia", "Espanha", "Estados Unidos", "Estônia", "Etiópia",
    "Fiji", "Filipinas", "Finlândia", "França", "Gabão", "Gâmbia", "Gana", "Geórgia", "Gibraltar", "Granada", "Grécia", "Gronelândia", "Guadalupe", "Guam", "Guatemala", "Guiana", "Guiana Francesa", "Guiné", "Guiné-Bissau", "Guiné Equatorial",
    "Haiti", "Honduras", "Hong Kong", "Hungria", "Iémen", "Ilha de Man", "Ilha Natal", "Ilhas Caimão", "Ilhas Cook", "Ilhas Faroé", "Ilhas Malvinas", "Ilhas Marshall", "Ilhas Salomão", "Ilhas Turcas e Caicos", "Ilhas Virgens Britânicas", "Ilhas Virgens Americanas", "Índia", "Indonésia", "Irão", "Iraque", "Irlanda", "Islândia", "Israel", "Itália",
    "Jamaica", "Japão", "Jersey", "Jordânia", "Kiribati", "Kuwait", "Laos", "Lesoto", "Letônia", "Líbano", "Libéria", "Líbia", "Liechtenstein", "Lituânia", "Luxemburgo",
    "Macau", "Macedônia do Norte", "Madagáscar", "Malásia", "Malaui", "Maldivas", "Mali", "Malta", "Marrocos", "Martinica", "Maurícia", "Mauritânia", "Mayotte", "México", "Micronésia", "Moldávia", "Mónaco", "Mongólia", "Montenegro", "Montserrat", "Myanmar",
    "Namíbia", "Nauru", "Nepal", "Nicarágua", "Níger", "Nigéria", "Niue", "Noruega", "Nova Caledônia", "Nova Zelândia", "Países Baixos", "Palau", "Palestina", "Panamá", "Papua-Nova Guiné", "Paquistão", "Paraguai", "Peru", "Polinésia Francesa", "Polónia", "Porto Rico",
    "Quênia", "Quirguistão", "Reino Unido", "República Centro-Africana", "República Checa", "República Dominicana", "Reunião", "Romênia", "Ruanda", "Rússia",
    "Saara Ocidental", "Samoa", "Samoa Americana", "Santa Helena", "Santa Lúcia", "São Bartolomeu", "São Cristóvão e Neves", "São Marinho", "São Martinho", "São Pedro e Miquelão", "São Tomé e Príncipe", "São Vicente e Granadinas", "Senegal", "Serra Leoa", "Sérvia", "Seychelles", "Singapura", "Sint Maarten", "Síria", "Somália", "Sri Lanka", "Sudão", "Sudão do Sul", "Suécia", "Suíça", "Suriname", "Svalbard e Jan Mayen",
    "Tailândia", "Taiwan", "Tajiquistão", "Tanzânia", "Território Britânico do Oceano Índico", "Timor-Leste", "Togo", "Tonga", "Trindade e Tobago", "Tunísia", "Turquemenistão", "Turquia", "Tuvalu",
    "Ucrânia", "Uganda", "Uruguai", "Uzbequistão", "Vanuatu", "Vaticano", "Venezuela", "Vietnã", "Wallis e Futuna", "Zâmbia", "Zimbabué"
  ];
  
  const allCountries = Array.from(new Set([...pisesPopulares, ...todosLosPaises]));
  
  const [deadline, setDeadline] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isGoogleSignup, setIsGoogleSignup] = useState(false);
  const [presencialCount, setPresencialCount] = useState(0);
  const [presencialLimit] = useState(250);
  const navigate = useNavigate();

  // Efeito para verificar se o e-mail pertence a um integrante do grupo
  useEffect(() => {
    const checkMembership = async () => {
      if (formData.email && formData.email.includes('@')) {
        setCheckingMembership(true);
        try {
          const q = query(collection(db, 'integrantes_giepei'), where('email', '==', formData.email.toLowerCase().trim()));
          const snap = await getDocs(q);
          const isMember = !snap.empty;
          setIsGroupMember(isMember);
          
          // Se o utilizador não for membro e estiver como apresentador, volta para ouvinte
          if (!isMember && formData.participatingAs === 'Apresentador') {
            setFormData(prev => ({ ...prev, participatingAs: 'Ouvinte' }));
          }
        } catch (err) {
          console.error("Erro ao verificar integrante:", err);
        }
        setCheckingMembership(false);
      } else {
        setIsGroupMember(false);
      }
    };

    const timer = setTimeout(() => {
      checkMembership();
    }, 800); // Debounce para não sobrecarregar o Firestore enquanto digita

    return () => clearTimeout(timer);
  }, [formData.email, formData.participatingAs]);

  useEffect(() => {
    const fetchDeadlineAndStatus = async () => {
      try {
        const snap = await getDoc(doc(db, 'settings', 'main'));
        if (snap.exists()) {
          const data = snap.data();
          const deadlineDate = data.registrationDeadline ? new Date(data.registrationDeadline) : null;
          const now = new Date();
          if (data.registrationOpen === false || (deadlineDate && now > deadlineDate)) {
            alert('As inscrições para este evento estão encerradas.');
            navigate('/');
            return;
          }
          if (data.registrationDeadline) setDeadline(data.registrationDeadline);
        }
        const statsSnap = await getDoc(doc(db, 'settings', 'registration_stats'));
        if (statsSnap.exists()) {
          const count = statsSnap.data().presencialCount || 0;
          setPresencialCount(count);
          if (count >= presencialLimit) setFormData(prev => ({ ...prev, attendanceMode: 'Online' }));
        }
      } catch (err) { console.error(err); }
    };
    fetchDeadlineAndStatus();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user && user.providerData[0]?.providerId === 'google.com') {
        setFormData(prev => ({ ...prev, name: user.displayName || '', email: user.email || '' }));
        setIsGoogleSignup(true);
      }
    });
    return () => unsubscribe();
  }, [navigate, presencialLimit]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    const finalValue = name === 'numAutores' ? parseInt(value) : value;

    if (name === 'participatingAs' && value === 'Apresentador' && formData.academicLevel === 'Estudante') {
      setFormData({ ...formData, participatingAs: value, academicLevel: 'Licenciado' });
    } else {
      setFormData({ ...formData, [name]: finalValue });
    }
  };

  const handleCheckboxChange = (linha: string) => {
    const current = formData.linhasAdicionais;
    if (current.includes(linha)) {
      setFormData({ ...formData, linhasAdicionais: current.filter(l => l !== linha) });
    } else {
      if (current.length < 5) setFormData({ ...formData, linhasAdicionais: [...current, linha] });
      else alert("Pode selecionar no máximo 5 linhas adicionais.");
    }
  };

  const selectAttendanceMode = (mode: string) => {
    if (mode === 'Presencial' && presencialCount >= presencialLimit) return;
    setFormData({ ...formData, attendanceMode: mode });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!formData.participatingAs) {
      setError("Por favor, selecione o Tipo de Participação.");
      setLoading(false);
      return;
    }

    if (formData.participatingAs === 'Apresentador') {
        if (!isGroupMember) {
          setError("Apenas integrantes do grupo GIEPEI podem inscrever-se para apresentar trabalhos.");
          setLoading(false);
          return;
        }
        if (!formData.linhaPrincipal) {
            setError("Selecione uma Linha de Investigação Prioritária.");
            setLoading(false);
            return;
        }
        if (!formData.temaTrabalho.trim()) {
            setError("Informe o tema do seu trabalho.");
            setLoading(false);
            return;
        }
        if (!trabalhoFile) {
            setError("Por favor, anexe o ficheiro do seu trabalho (PDF ou DOCX).");
            setLoading(false);
            return;
        }
    }

    try {
      if (formData.attendanceMode === 'Presencial') {
        const statsSnap = await getDoc(doc(db, 'settings', 'registration_stats'));
        const currentCount = statsSnap.exists() ? statsSnap.data().presencialCount : 0;
        if (currentCount >= presencialLimit) {
          setError('As vagas para a modalidade Presencial se esgotaram.');
          setPresencialCount(currentCount);
          setLoading(false);
          return;
        }
      }

      let uid = "";
      if (!isGoogleSignup) {
        const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
        uid = userCredential.user.uid;
      } else { uid = auth.currentUser?.uid || ""; }
      
      if (!uid) throw new Error("Usuário não identificado.");

      let trabalhoUrl = "";
      if (formData.participatingAs === 'Apresentador' && trabalhoFile) {
          const fileName = `${uid}_${Date.now()}_${trabalhoFile.name}`;
          const { error: uploadError } = await supabase.storage.from('files').upload(`trabalhos/${fileName}`, trabalhoFile);
          if (uploadError) throw uploadError;
          const { data: { publicUrl } } = supabase.storage.from('files').getPublicUrl(`trabalhos/${fileName}`);
          trabalhoUrl = publicUrl;
      }

      const submissionData = {
        ...formData,
        password: '',
        trabalhoUrl: trabalhoUrl,
        createdAt: new Date(),
        asistencia: { dia1: false, dia2: false, dia3: false },
        elegible: false
      };

      await setDoc(doc(db, 'participantes', uid), submissionData, { merge: true });

      if (formData.attendanceMode === 'Presencial') {
        const statsRef = doc(db, 'settings', 'registration_stats');
        const statsSnap = await getDoc(statsRef);
        const newCount = (statsSnap.exists() ? statsSnap.data().presencialCount : 0) + 1;
        await setDoc(statsRef, { presencialCount: newCount }, { merge: true });
      }
      alert('Inscrição confirmada com sucesso!');
      navigate('/perfil');
    } catch (err: any) {
      setError("Erro ao salvar dados: " + (err.message || "Tente novamente."));
    }
    setLoading(false);
  };

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    try { await signInWithPopup(auth, provider); } catch (err: any) { setError('Erro no Google Login: ' + err.message); }
  };

  return (
    <div className="registration-page container">
      <div className="registration-card">
        {deadline && <CountdownTimer deadline={deadline} />}
        <h2>Inscrição para o 1º Seminário do GIEPEI</h2>
        <p>Preencha os dados abaixo para garantir sua participação.</p>

        {!isGoogleSignup && (
          <button onClick={handleGoogleLogin} className="btn-google" type="button">Conectar com Google</button>
        )}

        <div className="divider"><span>Dados de Inscrição</span></div>

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
                <label>Tipo de Participação *</label>
                <select name="participatingAs" value={formData.participatingAs} onChange={handleInputChange} required>
                    <option value="">Selecione o tipo...</option>
                    <option value="Ouvinte">Ouvinte (Apenas assistir)</option>
                    {isGroupMember && (
                      <option value="Apresentador">Apresentar Trabalho / Investigação</option>
                    )}
                </select>
                {formData.email && !isGroupMember && !checkingMembership && (
                  <p style={{ fontSize: '0.7rem', color: '#888', marginTop: '0.4rem' }}>
                    Nota: Apenas integrantes do GIEPEI podem apresentar trabalhos.
                  </p>
                )}
                {checkingMembership && (
                  <p style={{ fontSize: '0.7rem', color: 'var(--secondary-color)', marginTop: '0.4rem' }}>
                    Verificando permissões de integrante...
                  </p>
                )}
            </div>
            <div className="form-group">
                <label>Modalidade *</label>
                <div className="attendance-options mini">
                    <div 
                        className={`attendance-option ${formData.attendanceMode === 'Presencial' ? 'active' : ''} ${presencialCount >= presencialLimit ? 'disabled' : ''}`}
                        onClick={() => selectAttendanceMode('Presencial')}
                    >
                        <div className="option-title">Presencial</div>
                        <div className="option-status">{presencialCount >= presencialLimit ? 'Esgotado' : `${presencialLimit - presencialCount} vagas`}</div>
                    </div>
                    <div className={`attendance-option ${formData.attendanceMode === 'Online' ? 'active' : ''}`} onClick={() => selectAttendanceMode('Online')}>
                        <div className="option-title">Online</div>
                        <div className="option-status">Ilimitadas</div>
                    </div>
                </div>
            </div>
          </div>

          <div className="form-group">
            <label>Nome Completo (Para o certificado) *</label>
            <input name="name" value={formData.name} onChange={handleInputChange} required />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>E-mail *</label>
              <input type="email" name="email" value={formData.email} onChange={handleInputChange} required disabled={isGoogleSignup} />
            </div>
            {!isGoogleSignup && (
              <div className="form-group">
                <label>Senha *</label>
                <input type="password" name="password" onChange={handleInputChange} required minLength={6} />
              </div>
            )}
          </div>

          {formData.participatingAs === 'Apresentador' && isGroupMember && (
            <div className="presentation-fields-container">
                <div className="form-group">
                    <label>Linha de Investigação Prioritária *</label>
                    <select name="linhaPrincipal" value={formData.linhaPrincipal} onChange={handleInputChange} required>
                        <option value="">Selecione a linha principal...</option>
                        {linhasInvestigacao.map(linha => (<option key={linha} value={linha}>{linha}</option>))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Tema do Trabalho / Investigação *</label>
                    <textarea name="temaTrabalho" value={formData.temaTrabalho} onChange={handleInputChange} placeholder="Título da sua pesquisa" required rows={3} style={{resize: 'none'}} className="form-input" />
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Número de Autores *</label>
                        <select name="numAutores" value={formData.numAutores} onChange={handleInputChange}>
                            <option value={1}>1 Autor (Você mesmo)</option>
                            <option value={2}>2 Autores</option>
                            <option value={3}>3 Autores</option>
                        </select>
                    </div>
                </div>

                <div className="authors-container" style={{ background: '#f5f5f5', padding: '1rem', borderRadius: '8px', marginBottom: '1rem' }}>
                    <div className="form-group">
                        <label>1º Autor (Inscrito)</label>
                        <input value={formData.name || 'Aguardando nome...'} disabled style={{ background: '#eee' }} />
                    </div>
                    {formData.numAutores >= 2 && (
                        <div className="form-group">
                            <label>2º Autor (Nome Completo) *</label>
                            <input name="autor2" value={formData.autor2} onChange={handleInputChange} placeholder="Nome do segundo autor" required />
                        </div>
                    )}
                    {formData.numAutores === 3 && (
                        <div className="form-group">
                            <label>3º Autor (Nome Completo) *</label>
                            <input name="autor3" value={formData.autor3} onChange={handleInputChange} placeholder="Nome do terceiro autor" required />
                        </div>
                    )}
                </div>

                <div className="form-group">
                    <label>Situação do Trabalho *</label>
                    <div className="radio-group">
                        <label className="radio-option"><input type="radio" name="situacaoTrabalho" value="Concluído" checked={formData.situacaoTrabalho === 'Concluído'} onChange={handleInputChange} /><span>Concluído</span></label>
                        <label className="radio-option"><input type="radio" name="situacaoTrabalho" value="Em Andamento" checked={formData.situacaoTrabalho === 'Em Andamento'} onChange={handleInputChange} /><span>Em Andamento</span></label>
                    </div>
                </div>

                <div className="form-group">
                    <label>Anexar Trabalho (PDF ou DOCX) *</label>
                    <input type="file" accept=".pdf,.docx,.doc" onChange={(e) => setTrabalhoFile(e.target.files?.[0] || null)} required />
                    <p style={{ fontSize: '0.75rem', color: '#666', marginTop: '0.3rem' }}>O ficheiro será guardado no repositório seguro do seminário.</p>
                </div>

                <div className="form-group">
                    <label>Linhas Adicionais para Acompanhamento (Até 5)</label>
                    <div className="checkbox-grid">
                        {linhasInvestigacao.map(linha => (
                            linha !== formData.linhaPrincipal && (
                                <label key={linha} className="checkbox-option">
                                    <input type="checkbox" checked={formData.linhasAdicionais.includes(linha)} onChange={() => handleCheckboxChange(linha)} />
                                    <span>{linha}</span>
                                </label>
                            )
                        ))}
                    </div>
                </div>
            </div>
          )}

          <div className="form-row">
            <div className="form-group"><label>Instituição *</label><input name="institution" value={formData.institution} onChange={handleInputChange} required /></div>
            <div className="form-group"><label>WhatsApp / Telefone</label><input name="phone" value={formData.phone} onChange={handleInputChange} /></div>
          </div>
          <div className="form-row">
            <div className="form-group">
                <label>Formação Acadêmica</label>
                <select name="academicLevel" value={formData.academicLevel} onChange={handleInputChange}>
                    {formData.participatingAs !== 'Apresentador' && <option value="Estudante">Estudante</option>}
                    <option value="Licenciado">Licenciado</option>
                    <option value="Mestre">Mestre</option>
                    <option value="Doctor">Doctor</option>
                </select>
            </div>
            <div className="form-group"><label>País</label><select name="country" value={formData.country} onChange={handleInputChange} required>{allCountries.map(country => (<option key={country} value={country}>{country}</option>))}</select></div>
          </div>

          {error && <p className="error-msg">{error}</p>}
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>{loading ? 'Processando...' : 'Confirmar Inscrição'}</button>
        </form>
      </div>
    </div>
  );
};

export default Registration;
